import { setOrDeleteQueryParams } from '@at/formatter-utils';
import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router';
export const useQueryParameters = () => {
    const reactRouterLocation = useLocation();
    const windowLocation = typeof window !== undefined && window.location;
    const { pathname, search } = windowLocation || reactRouterLocation;
    const queryParams = useMemo(() => new URLSearchParams(search), [search]);
    const getQueryParamsObject = useCallback(() => {
        const queryParamsObject = {};
        [...queryParams].map(([key, value]) => {
            queryParamsObject[key] = value;
        });
        return queryParamsObject;
    }, [queryParams]);
    const getQueryParamsString = useCallback((additionalParams) => {
        const queryParamsToStringify = new URLSearchParams([...queryParams]);
        if (additionalParams) {
            setOrDeleteQueryParams(queryParamsToStringify, additionalParams);
        }
        return queryParamsToStringify.toString() ? `?${queryParamsToStringify.toString()}` : '';
    }, [queryParams]);
    const setQueryParamsAndHistory = useCallback((updatedKeyValues, replaceState) => {
        const currentPath = `${pathname}${getQueryParamsString()}`;
        setOrDeleteQueryParams(queryParams, updatedKeyValues);
        const newPath = `${pathname}${getQueryParamsString()}`;
        if (currentPath !== newPath) {
            replaceState ? history.replaceState({}, '', newPath) : history.pushState({}, '', newPath);
        }
    }, [pathname, getQueryParamsString, queryParams]);
    return {
        pathname,
        search,
        queryParams,
        getQueryParamsObject,
        getQueryParamsString,
        setQueryParamsAndHistory,
    };
};
